import i18n from '@/shared/i18n';

/**
 * Nom de pays localisé : le serveur envoie le nom FRANÇAIS (dictionnaire
 * Vinted) + l'isoCode. En anglais, Intl.DisplayNames du navigateur traduit
 * depuis l'isoCode — zéro dictionnaire à maintenir. Repli : nom serveur.
 */
export const localizeCountryName = (isoCode: string | null | undefined, fallback: string): string => {
  if (!isoCode || !i18n.language?.startsWith('en')) return fallback;
  try {
    return new Intl.DisplayNames(['en'], { type: 'region' }).of(isoCode.toUpperCase()) ?? fallback;
  } catch {
    return fallback;
  }
};
